// A read the network fails is worth one more try a moment later. On a network change Chrome fails every request in
// flight, and the next ones go through; a blip in a page's first second used to cost it the renderer ("The 3D view
// isn't on this server") and the scene ("Couldn't open Explore · Failed to fetch"), until a reload. An answer from the
// server, a 404 say, is no network failure, and isn't asked for again. Every pack read takes its try in the page's
// fetch (data/packs.ts), the engine's included; the engine's own start takes its in viewport/wgpu.ts.

/** What fetch() and import() reject with when they get no answer: Chrome's "Failed to fetch", "network error" (a body
 *  cut off) and "Failed to fetch dynamically imported module", Safari's "Load failed", Firefox's "NetworkError when
 *  attempting to fetch resource" and "error loading dynamically imported module". */
const NO_ANSWER = /fetch|network|load failed|connection|imported module|module script/i;

/** Whether the network failed `err`'s read, or the server failed it for now: a TypeError with no answer, or a reader's
 *  `<url>: HTTP 5xx`. A programming error's TypeError ("x is not a function") isn't. */
export function networkFailed(err: unknown): boolean {
  if (err instanceof TypeError) return NO_ANSWER.test(err.message);
  return err instanceof Error && /: HTTP 5\d\d$/.test(err.message);
}

/** How long a read the network failed waits for its one more try. */
export const RETRY_MS = 1500;

export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/** `f(false)`, and `f(true)` `RETRY_MS` later if the network failed it. */
export async function onceMore<T>(f: (again: boolean) => Promise<T>, wait: (ms: number) => Promise<void> = sleep): Promise<T> {
  try {
    return await f(false);
  } catch (err) {
    if (!networkFailed(err)) throw err;
    await wait(RETRY_MS);
    return f(true);
  }
}
